import React from 'react'
import './PropertiesLinks.css';

const PropertiesLinks = () => {
  return (
    <div className="properties-links-container">
        <div className="properties-links-header">
            <h2> Explore Properties</h2>
        </div>
        <div className="properties-links-content">
            <div className="properties-links sale-link">
                <p className='properties-links-desktop-p'>We have several types of houses in Multan and also in other cities. Select the house that fits your requirements and budget by clicking on the link.</p>
                <div className='properties-links-div'>
            <a href="/for-sale">Buy</a>
            <p className='properties-links-mobile-p'>We have several types of houses in Multan and also in other cities. Select the house that fits your requirements and budget by clicking on the link.</p>
            </div>
            <i class="ri-arrow-right-line"></i>
            </div>
            <div className="properties-links rent-link">
            <p className='properties-links-desktop-p'>Gladious is offering you safe, secure and affordable houses for rent and will help you find your dream home without any hassle.</p>
            <div className='properties-links-div'>
            <a href="/for-rent">Rent</a>            
            <p className='properties-links-mobile-p'>Gladious is offering you safe, secure and affordable houses for rent and will help you find your dream home without any hassle.</p>
            </div>
            <i class="ri-arrow-right-line"></i>


        </div>
        </div>
    </div>
  )
}

export default PropertiesLinks